import './AnalyticsGuide.css';

/**
 * DataQualityBadge — shows a pill badge indicating the reliability of the displayed data.
 *
 * Props:
 *   status  ('complete' | 'partial' | 'unavailable' | 'needs_validation')
 *   note    (string, optional) – extra context shown next to the badge
 */
const STATUS_CONFIG = {
    complete: {
        label: 'Dati completi',
        className: 'dq-badge--complete',
        icon: '✓',
    },
    partial: {
        label: 'Dati parziali',
        className: 'dq-badge--partial',
        icon: '~',
    },
    unavailable: {
        label: 'Dati non disponibili',
        className: 'dq-badge--unavailable',
        icon: '—',
    },
    needs_validation: {
        label: 'Richiede validazione',
        className: 'dq-badge--needs-validation',
        icon: '?',
    },
};

export default function DataQualityBadge({ status, note }) {
    const config = STATUS_CONFIG[status] || STATUS_CONFIG.needs_validation;

    return (
        <span className={`dq-badge ${config.className}`} title={note || config.label}>
            <span className="dq-badge-icon">{config.icon}</span>
            {config.label}
            {note && <span className="dq-badge-note"> — {note}</span>}
        </span>
    );
}
